import { sagas as renewalsSagas } from './modules/renewals'

export default [...renewalsSagas]
